import React from "react";
import { Check } from "lucide-react";

/**
 * EnrollStepper — 3-step horizontal progress: Plan elegido → Tus datos →
 * Revisar. Driven by the parent's `currentStep` ("datos" | "review").
 *
 * - "datos"  ⇒ step 2 active, step 1 done
 * - "review" ⇒ step 3 active, steps 1+2 done
 * - Hidden by parent when the order is already submitted.
 */
export default function EnrollStepper({ currentStep }) {
  const steps = [
    { key: "plan", label: "Plan elegido" },
    { key: "datos", label: "Tus datos" },
    { key: "review", label: "Revisar" },
  ];
  const activeIdx = currentStep === "review" ? 2 : 1; // plan is always done

  return (
    <ol
      className="mb-10 grid grid-cols-3 gap-2 sm:gap-3 max-w-[640px] mx-auto"
      data-testid="enroll-stepper"
    >
      {steps.map((s, i) => {
        const done = i < activeIdx;
        const active = i === activeIdx;
        return (
          <li
            key={s.key}
            className="flex flex-col items-center text-center min-w-0"
            data-testid={`enroll-step-${s.key}`}
          >
            <div className="flex items-center w-full">
              <span
                aria-hidden
                className={`flex-1 h-px ${
                  i === 0
                    ? "invisible"
                    : done || active
                    ? "bg-velcor-green"
                    : "bg-slate-200"
                }`}
              />
              <span
                className={`grid place-items-center w-8 h-8 rounded-full text-[12px] font-extrabold shrink-0 transition-colors ${
                  done
                    ? "bg-velcor-green text-white"
                    : active
                    ? "bg-velcor-ink text-white ring-4 ring-velcor-ink/10"
                    : "bg-slate-100 text-slate-400"
                }`}
              >
                {done ? <Check className="w-4 h-4" strokeWidth={2.6} /> : i + 1}
              </span>
              <span
                aria-hidden
                className={`flex-1 h-px ${
                  i === steps.length - 1
                    ? "invisible"
                    : done
                    ? "bg-velcor-green"
                    : "bg-slate-200"
                }`}
              />
            </div>
            <div
              className={`mt-2 text-[11.5px] font-extrabold uppercase tracking-[0.08em] truncate ${
                done || active ? "text-velcor-ink" : "text-slate-400"
              }`}
            >
              {s.label}
            </div>
          </li>
        );
      })}
    </ol>
  );
}
